import external from "@/gavnoCode/external";
import errorHandlerExternal from "@/plugins/errorHandlerExternal";
import router from "@/router";

const state = {
  isDeveloper: localStorage.getItem('Position') === '365' || localStorage.getItem('Position') === '355',
  TEST: 0,
  NP: localStorage.getItem('UserID') === '75889',
  // NP: localStorage.getItem('UserID') === '105926',
  tablesList: [],
  tablesObj: {
    EPgreed: {},
    PEgreed: {},
    dateDiscrepancy: {},
    sverSumm: {},
    topUp_greed: {},
    oneCaccountObj: {},
    RPgreed2: {},
    RPgreed3: {},
    RPgreed4: {},
    recommendedGreed: {},
    failedDPgreed: {},
    failedLongations: {},
    outstandingPayments: {},
    unknownPayments: {},
    inPaysNotPolotno: {},
    inPolotnoNotPays: {},
    Inequality76051: {},
    Inequality76093: {},
    CheckDoubleOrders: {},
    CheckPairTrans: {},
    CheckMinusSumTrans: {},
    remains_greed1: {},
    remains_greed2: {},
    remains_greed3: {},
    remains_greed4: {},
    summaryTable: {},
  },
  operday: '',
  currentTab: '',
  statementOfChecks: {
    vyd: {counter: 0, check: false},
    sver: {counter: 0, check: false},
    so: {counter: 0, check: false},
    pp: {counter: 0, check: false},
    ps: {counter: 0, check: false},
    op: {counter: 0, check: false},
    po: {counter: 0, check: false},
    st: {counter: 0, check: false},
  },
  canCloseOperDay: false,
  calcInProgress: false,
  calcStatus: '',
  remCalc: false,
  summCalc: false,
  summPeriodCalc: false,
  vitrinaCalc: false
};

const getters = {
};

const actions = {
  DailyCheckList: ({commit, dispatch}) => {
    console.log('чек лист');
    commit('loadingStatus', true);
    external.universalRequest({
      externalType: 'ms',
      msUrl: 'back-loannp/Buh/DailyCheckList',
      method: 'GET',
    }).then((res) => {
      dispatch('prepareTablesList', res.list);
      dispatch('collectCheckResults', res.list);
      commit('setOperday', res.dtOperDay);
      commit('loadingStatus',false);
    }).catch(res => {
      alert('DailyCheckList catch');
      errorHandlerExternal(res, router, 'DailyCheckList');
      commit('loadingStatus', false);
    })
  },
  collectCheckResults: ({commit}, list) => {
    console.log('collectCheckResults');
    let vyd = [1, 2, 3, 4, 5, 26];
    let vydStatus = 0;
    for (let i=0; i<vyd.length; i++) {
      let finded = list.find(index => index.tableID === vyd[i]);
      if (finded.checkResult === -1) {
        vydStatus = -1
        commit('saveChecksStatus', {status: vydStatus, target: 'vyd', check: vydStatus === vyd.length });
        break;
      } else if (finded.checkResult > 0) {
        vydStatus++
      } else break
      commit('saveChecksStatus', {status: vydStatus, target: 'vyd', check: vydStatus === vyd.length });
    }

    let sver = [6, 7, 8];
    let sverStatus = 0;
    for (let i=0; i<sver.length; i++) {
      let finded = list.find(index => index.tableID === sver[i]);
      if (finded.checkResult === -1) {
        sverStatus = -1
        commit('saveChecksStatus', {status: sverStatus, target: 'sver', check: sverStatus === sver.length});
        break;
      } else if (finded.checkResult > 0) {
        sverStatus++
      } else break
      commit('saveChecksStatus', {status: sverStatus, target: 'sver', check: sverStatus === sver.length});
    }

    let so = [9, 10, 11];
    let soStatus = 0;
    for (let i=0; i<so.length; i++) {
      let finded = list.find(index => index.tableID === so[i]);
      if (finded.checkResult === -1) {
        soStatus = -1
        commit('saveChecksStatus', {status: soStatus, target: 'so', check: soStatus === so.length});
        break;
      } else if (finded.checkResult > 0) {
        soStatus++
      } else break
      commit('saveChecksStatus', {status: soStatus, target: 'so', check: soStatus === so.length});
    }

    let pp = [12, 13, 14, 15];
    let ppStatus = 0;
    for (let i=0; i<pp.length; i++) {
      let finded = list.find(index => index.tableID === pp[i]);
      if (finded.checkResult === -1) {
        ppStatus = -1
        commit('saveChecksStatus', {status: ppStatus, target: 'pp', check: ppStatus === pp.length});
        break;
      } else if (finded.checkResult > 0) {
        ppStatus++
      } else break
      commit('saveChecksStatus', {status: ppStatus, target: 'pp', check: ppStatus === pp.length});
    }

    let ps = [16, 17];
    let psStatus = 0;
    for (let i=0; i<ps.length; i++) {
      let finded = list.find(index => index.tableID === ps[i]);
      if (finded.checkResult === -1) {
        psStatus = -1
        commit('saveChecksStatus', {status: psStatus, target: 'ps', check: psStatus === ps.length});
        break;
      } else if (finded.checkResult > 0) {
        psStatus++
      } else break
      commit('saveChecksStatus', {status: psStatus, target: 'ps', check: psStatus === ps.length});
    }

    let op = [18, 19, 20];
    let opStatus = 0;
    for (let i=0; i<op.length; i++) {
      let finded = list.find(index => index.tableID === op[i]);
      if (finded.checkResult === -1) {
        opStatus = -1
        commit('saveChecksStatus', {status: opStatus, target: 'op', check: opStatus === op.length});
        break;
      } else if (finded.checkResult > 0) {
        opStatus++
      } else break
      commit('saveChecksStatus', {status: opStatus, target: 'op', check: opStatus === op.length});
    }

    let po = [21, 22, 23, 24];
    let poStatus = 0;
    for (let i=0; i<po.length; i++) {
      let finded = list.find(index => index.tableID === po[i]);
      if (finded.checkResult === -1) {
        poStatus = -1
        commit('saveChecksStatus', {status: poStatus, target: 'po', check: poStatus === po.length});
        break;
      } else if (finded.checkResult > 0) {
        poStatus++
      } else break
      commit('saveChecksStatus', {status: poStatus, target: 'po', check: poStatus === po.length});
    }

    let st = [25];
    let stStatus = 0;
    for (let i=0; i<st.length; i++) {
      let finded = list.find(index => index.tableID === st[i]);
      if (finded.checkResult === -1) {
        stStatus = -1
        commit('saveChecksStatus', {status: stStatus, target: 'st', check: stStatus === st.length});
        break;
      } else if (finded.checkResult > 0) {
        stStatus++
      } else break
      commit('saveChecksStatus', {status: stStatus, target: 'st', check: stStatus === st.length});
    }

  },
  prepareTablesList: ({commit}, tablesList) => {
    let count = 0;
    for (let i=0; i<tablesList.length; i++) {
      if ( tablesList[i].checkResult !== 1 ) {
        count ++
      }
      tablesList[i]['showButtons'] = true;
    }
    commit('setClosingStatement', count === 0)

    commit('setTablesList', tablesList)
  },
  getNeededObj: ({commit}, dataObj) => {
    let findedObj = state.tablesList.findIndex(index => index.tableID === dataObj.id);
    if (findedObj >= 0) {
      commit('addTablesObj', {obj: state.tablesList[findedObj],name: dataObj.name})
    }
  },
  getCalcStatus: ({commit}, statusObj) => {
    let status = '';
    switch (statusObj.statusRes) {
      case 1: status = 'Расчет завершился успешно';
      break;
      case -1: status = 'Расчет завершился с ошибкой';
      break;
      case 0: status = 'В процессе';
      break;
      case 100: status = 'Расчет не проводился';
      break;
      default: break;
    }
    commit('setCalcStatus', status);
  },
};

const mutations = {
  setLoopValue:(state, loopObj) => {state[loopObj.loopTarget] = loopObj.value},
  setTest:(state, value) => state.TEST = value,
  setSelectedTab:(state, value) => state.currentTab = value,
  setTablesList:(state, tablesArray) => {
    state.tablesList = tablesArray
  },
  addTablesObj: (state, newTableObj) => state.tablesObj[newTableObj.name] = newTableObj.obj,
  setOperday:(state, value) => {
    state.operday = value
  },
  setClosingStatement:(state, value) => state.canCloseOperDay = value,
  setCalcProgress: (state, value) => state.calcInProgress = value,
  setCalcStatus: (state, value) => state.calcStatus = value,
  saveChecksStatus: (state, obj) => {
    state.statementOfChecks[obj.target].counter = obj.status;
    state.statementOfChecks[obj.target].check = obj.check;
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
}
